import React from 'react';
import Select, { SelectProps } from 'antd/lib/select';
import { useQuery } from 'react-query';
import {
  getMyMgCompanyList,
  MGCompanyListResponse,
} from '../../services/parametersService';
import { noop } from 'lodash';
export type MgCompanyListProps = SelectProps<any> & {
  onSelected?: (mg: MGCompanyListResponse) => void;
};
const MgCompanyList = ({
  onSelected,
  onChange = noop,
  value,
  ...props
}: MgCompanyListProps) => {
  const { data } = useQuery('getUserMgCompanyList', () =>
    getMyMgCompanyList().then((res) => res.list || [])
  );

  const handleChange: SelectProps<any>['onChange'] = (value, option) => {
    onChange(value, option);
    if (onSelected) {
      onSelected(data?.find((item) => item.mgid === value)!);
    }
  };

  return (
    <Select onChange={handleChange} value={value} {...props}>
      {data?.map((company: MGCompanyListResponse) => (
        <Select.Option value={company.mgid} key={company.mgid}>
          {company.mgname}
        </Select.Option>
      ))}
    </Select>
  );
};

export default MgCompanyList;
